import {
  createFrontendPlugin,
  PageBlueprint,
} from '@backstage/frontend-plugin-api';
import { PageErrorBoundary } from '@vivicta/ui';

const operationsPage = PageBlueprint.make({
  params: {
    path: '/operations',
    noHeader: true,
    loader: () =>
      import('./components/OperationsPortalPage').then(m => (
        <PageErrorBoundary title="Operations">
          <m.OperationsPortalPage />
        </PageErrorBoundary>
      )),
  },
});

export default createFrontendPlugin({
  pluginId: 'vivicta-operations-portal',
  extensions: [operationsPage],
});
